import React from 'react'
import { Typography, createStyles, withStyles } from '@material-ui/core'
import { Link } from 'gatsby'

const styles = () => {
  const textStyles = {
    color: 'black',
    fontSize: '1.25rem',
    fontWeight: 500,
  }
  return createStyles({
    link: {
      textDecoration: 'none',
    },
    text: textStyles,
  })
}

const PageLink = ({ classes, to, children, onClick }) => {
  return (
    <Link className={classes.link} to={to} onClick={onClick}>
      <Typography className={classes.text}>{children}</Typography>
    </Link>
  )
}

export default withStyles(styles)(PageLink)
